import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { keypressEnterOrSpace } from '../../lib/keyHandler';
import styles from './tab.css';
var cx = classnames.bind(styles);
export default function Tab(_ref) {
  var defaultActiveIndex = _ref.activeIndex,
      color = _ref.color,
      fluid = _ref.fluid,
      onTabChange = _ref.onTabChange,
      padded = _ref.padded,
      panes = _ref.panes,
      renderActiveOnly = _ref.renderActiveOnly,
      rounded = _ref.rounded,
      rest = _objectWithoutProperties(_ref, ["activeIndex", "color", "fluid", "onTabChange", "padded", "panes", "renderActiveOnly", "rounded"]);

  var _useState = useState(defaultActiveIndex < 0 ? 0 : Math.min(defaultActiveIndex, panes.length - 1)),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  useEffect(function () {
    setActiveIndex(defaultActiveIndex < 0 ? 0 : Math.min(defaultActiveIndex, panes.length - 1));
  }, [defaultActiveIndex, panes.length]);
  var createTabClickHandler = useCallback(function (i) {
    return function () {
      onTabChange(i);
      setActiveIndex(i);
    };
  }, [onTabChange]);
  return React.createElement("div", rest, React.createElement("div", {
    className: cx('tabMenu', {
      rounded: rounded
    })
  }, panes.map(function (_ref2, i) {
    var _cx;

    var label = _ref2.label;
    return React.createElement("a", {
      className: cx('tabMenuItem', (_cx = {}, _defineProperty(_cx, color, styles[color]), _defineProperty(_cx, "fluid", fluid), _defineProperty(_cx, "active", activeIndex === i), _cx)),
      key: i.toString(),
      onClick: createTabClickHandler(i),
      onKeyPress: keypressEnterOrSpace(createTabClickHandler(i)),
      role: "tab",
      tabIndex: i
    }, label);
  })), React.createElement("div", null, panes.map(function (_ref3, i) {
    var content = _ref3.content;
    var isActive = activeIndex === i;
    var shouldRender = !renderActiveOnly || renderActiveOnly && isActive;

    if (!shouldRender) {
      return null;
    }

    return React.createElement("div", {
      className: cx('tabContent', {
        contentPadding: padded,
        active: activeIndex === i
      }),
      key: i.toString()
    }, typeof content === 'function' ? content() : content);
  })));
}
Tab.propTypes = {
  /** Integer for the desired active tab index. Will match closest index. */
  activeIndex: PropTypes.number,

  /** Boolean to indicate of only the active pane should be rendered */
  renderActiveOnly: PropTypes.bool,

  /** Array of objects with tab menu item and content */
  panes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]).isRequired
  })),
  onTabChange: PropTypes.func,

  /** Additional className for the root object */
  className: PropTypes.string,

  /** If tabs should fill width of tab parent menu section */
  fluid: PropTypes.bool,

  /** Color property */
  color: PropTypes.string,

  /** If first and last tabs should be rounded */
  rounded: PropTypes.bool,

  /** Applies padding for tab content */
  padded: PropTypes.bool
};
Tab.defaultProps = {
  activeIndex: 0,
  renderActiveOnly: false,
  panes: [],
  onTabChange: function onTabChange() {},
  className: undefined,
  fluid: false,
  color: 'white',
  rounded: false,
  padded: true
};